var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between"},_vm._l((_vm.chars),function(c,i){return _c('div',{key:i,domProps:{"innerHTML":_vm._s(c)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }